/**
 * @packageDocumentation
 * @module f1/boolean
 */

/**
 * A curried `f1.not` function ready to receive the the `a` parameter
 *
 * @param y the second condition
 */
export type NotValue<V> = (a: (v: V) => boolean) => boolean;

export interface Not {
  /**
   * Same as `!a`.
   *
   * @public
   * @function f1.not
   * @param a the first condition
   * @example
   *
   * ```ts
   * not(() => false, '') === true
   * not(() => true, '') === false
   * ```
   */
  <V>(a: (v: V) => boolean, v: V): boolean;
  /**
   * {@link FnNotValue}
   * @param a the first condition
   */
  <V>(a: (v: V) => boolean): NotValue<V>;
}

/**
 * @see Not
 */
export default <V>(a: (v: V) => boolean, v: V) => !a(v);
